<div class="d-flex flex-md-row mb-3 ml-3 mr-3">
    <app-content-header [historyBack]="false" (backEvent)="onBack()"
        [headline]="'integration_apps_details_header' | i18next"></app-content-header>
</div>

@if (integrationApp === undefined) {
<app-no-content-message t="no_integration_app_details"></app-no-content-message>
}

@if (integrationApp) {
<app-integration-apps-detail-card
  [integrationApp]="integrationApp"
  [integrationAppVersion]="integrationAppVersion"
  [integrationAppOwnerId]="integrationAppOwnerId"
  [preselectedSubId]="preselectedSubId"
  [preselectedSubName]="preselectedSubName" 
  [isAdmin]="isAdmin"
  (install)="startInstallationProcess($event)">
</app-integration-apps-detail-card>
}

<div class="d-flex flex-md-row mt-5 flex-wrap">
    <div class="h4 ml-3 align-self-center">{{'integration_apps_details_installed_header' | i18next}} ({{
        subscriptionsWithAppInstalledInitial.length }})</div>
    <div class="d-flex flex-md-row ml-auto align-items-center">
        <app-filter (searchFilterChanged)="filter($event)" style="width: 300px;"
            [placeholder]="'integration_apps_search_subscriptions_placeholder' | i18next"></app-filter>
    </div>
</div>

@if (subscriptionsWithAppInstalledInitial && subscriptionsWithAppInstalledInitial.length === 0) {
<app-no-content-message t="no_subscriptions_with_integration_app_installed"></app-no-content-message>
}

<div class="row align-items-stretch mt-2">
    @for (subWithVersion of subscriptionsWithAppInstalledToDisplay; track $index) {
    <app-subscription-card class="col-xs-12 col-md-6 col-lg-6 mb-3" [subscription]="subWithVersion.sub" [detaillist]="false" 
        [installationState]="subWithVersion.state" [installedVersion]="subWithVersion.version" [currentAppVersion]="integrationAppVersion" 
        (upgradeAppInstallation)="startAppInstallationUpgrade($event)" (retryInstallOrUpgradeRequest)="retryInstallation($event)">
        @if (isAdmin) {
            <div titlemenu>
                <div class="d-flex flex-row ml-3">
                    <div class="custom-dropdown-menu ml-2" ngbDropdown display="dynamic" placement="bottom-right">
                        <div class="btn bg-transparent p-0 m-0 hide-dropdown-icon" id="dropdownBasic2" ngbDropdownToggle>
                            <i class="fas fa-ellipsis-v icon-size-big"></i>
                        </div>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic2">
                            <div class="cursor-pointer dropdown-item"
                                (click)="confirmUninstallation(subWithVersion.sub.appliance_id)">
                                <span class="d-flex">
                                    <i class="fa fa-ban red icon-size-big mr-2"></i>
                                    <span>{{ 'integration_apps_uninstall_hint' | i18next }}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }
    </app-subscription-card>
    }
</div>

<app-integration-apps-dialog [(showDialog)]="showDialog" [(contentType)]="dialogContentType"
    [selectedAppId]="integrationAppId" [subscriptionList]="subscriptionsToShowForInstallation" [failedInstallationApplianceIds]="failedInstallationApplianceIds"
    [preselectedSubscription]="preselectedSubscription" [previousApiPermissions]="previousApiPermissions" [isUpgrade]="isUpgrade"
    (uninstall)="startUninstallation()" (installationSuccess)="installationSuccess()"></app-integration-apps-dialog>